import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "资源导航", to: "/ziyuan" },
  { label: "韩漫APP", to: "/app" },
  { label: "新作推荐", to: "/tuijian" },
  { label: "文章专题", to: "/article" },
  { label: "常见问题", to: "/faq" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const isActive = (to: string) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-950/95 backdrop-blur border-b border-background-200/70 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <nav className="mx-auto max-w-7xl px-4 md:px-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5">
          <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-lg comic-pop font-bold">
            韩漫
          </span>
          <span className="font-heading text-xl md:text-2xl text-foreground-950 leading-none">
            韩国免费漫画
            <span className="block text-[10px] text-foreground-500 font-body tracking-widest mt-0.5">
              KO-MANHWA NAV
            </span>
          </span>
        </Link>

        <ul className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <li key={item.to}>
              <Link
                to={item.to}
                className={`px-3.5 py-2 rounded-md text-sm whitespace-nowrap transition-colors ${
                  isActive(item.to)
                    ? "text-primary-500 bg-primary-100/60 font-bold"
                    : "text-foreground-800 hover:text-primary-500 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="hidden lg:flex items-center gap-2.5">
          <Link
            to="/tuijian"
            className="text-sm px-4 py-2 rounded-md border border-background-300/70 text-foreground-800 hover:border-primary-400 hover:text-primary-500 transition-colors whitespace-nowrap"
          >
            收藏本站
          </Link>
          <Link
            to="/contact"
            className="text-sm px-4 py-2 rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap font-bold"
          >
            意见反馈
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="切换菜单"
          className="lg:hidden w-10 h-10 rounded-md bg-background-100 flex items-center justify-center text-foreground-800"
        >
          <i className={`ri-${open ? "close" : "menu"}-line text-xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-background-950/98 border-b border-background-200/70 px-4 py-3">
          <ul className="flex flex-col gap-1">
            {navItems.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className={`block px-3 py-2.5 rounded-md text-sm ${
                    isActive(item.to)
                      ? "text-primary-500 bg-primary-100/60 font-bold"
                      : "text-foreground-800 hover:bg-background-100"
                  }`}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}